import { Box, Typography } from "@mui/material";
import React, { memo } from "react";

type GroupHeaderProps = {
    title: string;
    count: number;
}

// WhatsApp Web search-result section label ("Chats", "Contacts"): accent-green
// heading on the sidebar background, no uppercase.
const GroupHeader = memo(({ title, count }: GroupHeaderProps) => {
    return (
        <Box
            sx={{
                padding: "16px 16px 8px 16px",
                backgroundColor: 'var(--wa-sidebar-bg)',
                position: 'sticky',
                top: 0,
                zIndex: 1,
            }}
        >
            <Typography
                variant="subtitle2"
                sx={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--wa-accent)',
                }}
            >
                {title} ({count})
            </Typography>
        </Box>
    );
});

export default GroupHeader; 